<!--
 * @Author: lishiqiao
 * @Date: 2022-03-01 10:36:33
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-19 16:04:54
-->
<template>
  <div class="page-list">
    <!-- 搜索栏 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>仓库&nbsp;:</label>
          <el-select v-model="params.params.groupId" filterable placeholder="请选择仓库">
            <el-option label="全部仓库" value=""></el-option>
            <el-option v-for="item in storeHouseList" :key="item.groupId" :label="item.groupName" :value="item.groupId">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>动保&nbsp;:</label>
          <el-select v-model="params.params.drugId" filterable placeholder="请选择动保">
            <el-option label="全部动保" value=""></el-option>
            <el-option v-for="item in drugList" :key="item.drugId" :label="item.drugName" :value="item.drugId">
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="page-search-btn">
        <div class="search-btn" @click="search">查询</div>
        <div class="reset-btn" @click="reset">重置</div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="page-list-content">
      <!-- 列表 -->
      <div class="page-list-title">
        <div><i class="title-icon"></i>动保实时有效库存</div>
        <div>单位 : {{ unitName }}</div>
        <div class="page-list-btns">
          <el-dropdown style="margin-right: 20px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <RouteTarget :pathName="'day-ym-drug-used'">
            <span class="switch-table">动保使用记录</span>
          </RouteTarget>
          <RouteTarget :pathName="'day-ym-drug-in-out'">
            <span class="switch-table">进出存</span>
          </RouteTarget>
          <span @click="exportTable">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <!-- 表格 -->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :row-class-name="tableRowClassName"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="groupName" label="仓库\区域"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="drugName" label="动保名称"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="spec" label="规格"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="specUnitName" label="计量单位">
        </el-table-column>
        <el-table-column prop="stockNumber" label="现存数量"> </el-table-column>
        <el-table-column prop="stockMoney" label="现存金额"> </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="uyu-pagination">
        <MyPagination @change="handleCurrentChange($event)" @changeSizes="handleSizeChange($event)"
          :sizes="[13, 26, 39, 50, 100, 200]" :pageNo.sync="params.currPage" :pageSize.sync="params.pageSize"
          :totalCount="totalCount">
        </MyPagination>
      </div>
    </div>
  </div>
</template>

<script>
import RouteTarget from "@/components/pc/route-target.vue";
import MyPagination from "@/components/pc/my-pagination.vue";
import service from "./ym-drug-service";
import Page from "@/utils/methods/page";
export default {
  name: "drug-stock",
  data() {
    return {
      unitName: "", // 单位名称
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "drugName",
          fixed: false,
          selected: false
        },
        {
          prop: "spec",
          fixed: false,
          selected: false
        },
        {
          prop: "specUnitName",
          fixed: false,
          selected: false
        },
      ],
      params: {
        currPage: 1, // 当前页
        pageSize: 13, // 每页条数
        orderBy: "desc",
        orderByName: "group_name",
        params: {
          orgId: "",
          groupId: "",
          drugId: "",
        },
      },
      totalCount: 0, // 总条数
      exportParams: {}, // 导出参数
      tableData: [],
      storeHouseList: [], // 仓库列表
      drugList: [], // 动保列表
    };
  },
  components: { MyPagination, RouteTarget },
  created() {
    this.tableHeight = window.innerHeight - 450;
    this.params.params.orgId = localStorage.getItem("orgId");
    this.unitName = localStorage.getItem("orgName");
    this.getStoreHouseList(); // 获取仓库列表
    this.getDrugList(); // 获取动保列表
    this.getPageList(); // 获取分页
  },
  mounted() {
    Page.pagesTableFixed(); // 表头固定
  },
  methods: {
    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 11:33:59
     * @description: 获取仓库列表
     * @param {*}
     */
    getStoreHouseList() {
      let params = {
        orgId: this.params.params.orgId,
      };
      service
        .getStoreHouseList(params)
        .then((res) => {
          if (res.code == "0000") {
            this.storeHouseList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 11:38:09
     * @description: 获取动保列表
     * @param {*}
     */
    getDrugList() {
      let params = {
        orgId: this.params.params.orgId,
      };
      service
        .getDrugList(params)
        .then((res) => {
          if (res.code == "0000") {
            this.drugList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 查询
    search() {
      this.getPageList();
    },

    // 重置
    reset() {
      this.params.params.groupId = "";
      this.params.params.drugId = "";
      this.getPageList();
    },

    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.drugName === "合计") {
        return "heji-row";
      }
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 14:17:40
     * @description: 分页
     * @param {*}
     */
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      service
        .getPageList(this.params)
        .then((res) => {
          if (res.code == "0000") {
            this.params.currPage = res.data.currPage;
            this.params.pageSize = res.data.pageSize;
            this.totalCount = res.data.totalCount;
            this.tableData = res.data.list;
            this.exportParams = JSON.parse(JSON.stringify(this.params.params));
          } else {
          }
          loading.close();
        })
        .catch((err) => {
          this.$message.error(err);
          loading.close();
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 14:17:53
     * @description: 导出
     * @param {*}
     */
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.exportParams.fileName = "动保实时有效库存";
          service
            .exportData(this.exportParams)
            .then((res) => { })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .catch((err) => { });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-07 10:07:26
     * @description: 切换单前页
     * @param {*} event
     */
    handleCurrentChange(event) {
      this.params.currPage = event;
      this.getPageList();
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-07 10:14:06
     * @description: 改变当前分页总数
     * @param {*} event
     */
    handleSizeChange(event) {
      this.params.pageSize = event;
      this.params.currPage = 1;
      this.getPageList();
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
};
</script>

<style lang="less" scoped></style>